import { render, staticRenderFns } from "./SdsTableSection8.vue?vue&type=template&id=32081151"
import script from "./SdsTableSection8.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection8.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports